// Login
export const FETCH_LOGIN_REQUEST = "FETCH_LOGIN_REQUEST"
export const FETCH_LOGIN_SUCCESS = "FETCH_LOGIN_SUCCESS"
export const INTIALIZE_TOKEN = "INTIALIZE_TOKEN"
export const REMOVE_TOKEN = "REMOVE_TOKEN"
export const FETCH_FORGET_SUCCESS = "FETCH_FORGET_SUCCESS"
export const INTIALIZE_LANG="INTIALIZE_LANG"
export const INTIALIZE_TYPE = "INTIALIZE_TYPE"
export const FETCH_LOGIN_FAILED = "FETCH_LOGIN_FAILED"

